import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazy(() => import('./Helmet.tsx')),
  Comments: lazyNamed(() => import('./pages/Comments/index.tsx'), 'Comments'),
  SystemNotifications: lazy(() => import('./pages/SystemNotifications/index.tsx')),
};
